export default __webpack_public_path__ + "static/media/snow.6f3b1511.png";